import CsiFormData from "csi/action/FormData";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import { NewFromController } from "csi/action/NewFromController";

const _AggregateProductMixin = declare(null, {
	/**
	 * @override
	 * Add aggregate test
	 */
	getFormData() {
		const fd = this.inherited(arguments) as unknown as CsiFormData;
		fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
		return fd;
	},

	/**
	 * Return true if a product is not in the affected products list
	 * @override
	 * @param {Context} ctx
	 * @param {FormData} fd
	 * @return {boolean}
	 */
	_canAggregate(ctx, fd) {
		const newFromController = this as unknown as NewFromController;
		const ecNode = newFromController.m_urlParent && ctx.cache.getNode(newFromController.m_urlParent);
		const affectedItemNodes = ctx.cache.getNodes(ecNode.AffectedItems);
		const affectedProduct = ecNode && affectedItemNodes.find((item) => (
			(ctx.getNodeURL() == item.ItemProduct) ||
			(item.ItemType == "ECItemType:FoodIngredient" && ctx.getNodeURL() == item.AffectedLibraryItem)
		));
		return !affectedProduct;
	},
});

export = _AggregateProductMixin;